import './Filter.css';
import { useState } from 'react'
import { Form, Button } from 'react-bootstrap'
import axios from "axios";


const Filter = ({ filter }) => {
    const [ formData, setFormData ] = useState({
        filter: '',
        since: '',
        until: ''
    })

    const handleFormChange = (e) => {
        const key = e.target.name;
        const value = e.target.value;
        console.log(key, value);
        setFormData({...formData, [key]: value})
    }

    const handleFormSubmit = (e) => {
        e.preventDefault();
        axios.post("http://localhost:3001/api/tweetscan", {formData})
        .then((response) => {
            console.log(response);
        });
    }

    const validateForm = () => {
        return  formData.filter.length > 0 && 
                formData.since.length > 0 && 
                formData.until.length > 0;
    }

    return (
        <div id = "FilterContainer">
            <Form id = "FilterForm" onSubmit={handleFormSubmit}>
                <Form.Group className="filterComponent" controlId="formHashtag">
                    <Form.Label>Filter:</Form.Label>
                    <Form.Control className="filterInput" name='filter'
                    rows="1" placeholder="Ex: #GISDEffect" 
                    value={formData.filter} onChange={handleFormChange} type="text"/>
                </Form.Group>
                <Form.Group className="filterComponent" controlId="formSinceDate">
                    <Form.Label>From:</Form.Label>
                    <Form.Control name='since' type="date" onChange={handleFormChange} className = "filterInput" value={formData.since}/>
                </Form.Group>
                <Form.Group className="filterComponent" controlId="formUntilDate">
                    <Form.Label>To:</Form.Label>
                    <Form.Control name='until' type="date" onChange={handleFormChange} className = "filterInput" value={formData.until}/>
                </Form.Group>
                <Button variant="primary" type="submit" disabled={!validateForm()}>
                    Analyze
                </Button>
            </Form>
        </div>
    );
};

export default Filter;